import { ProcessSelectionActionType, ProcessSelectionConfiguration } from './../../tmc-common/widgets/terminal/process-selection/process-selection.model';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { ProcessSelectOption } from 'src/tmc-common/widgets/terminal/process-selection/process-selection.model';
import { environment } from 'src/environments/environment';
import { VisitorType } from '../tmc-visit.model';
import { HttpService } from '@sdbn/appclient';

export class VisitorTypeSelectionController extends AbstractStepController {

  private httpService: HttpService;

  selectOptions = new Array<ProcessSelectOption>();


  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedProcessOption' && contextChange.value != null) {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
    }
  }

  onRegisterToDashboardContext() {
    this.httpService = WizardServiceLocator.injector.get(HttpService);
    this.dashboardContext.setContextValue('selectedProcessOption', null);
    this.dashboardContext.setContextValue('dashboardConfiguration', null);
    this.buildAndApplySelectionModelToContext();
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('visitor type selection started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);
    const dialogData: ConfirmDialogData = {
      titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
      confirm: () => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    };
    matDialog.open(ConfirmDialogComponent, {
      data: dialogData
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }

  private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
    this.wizardComponent.stopInactivityMonitoring();
    this.dashboardContext.setContextValue('visitorType', selectedProcessOption.key);
    if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
      this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
    } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
      this.wizardComponent.next(selectedProcessOption.processStepKey);
    } else {
      console.error('Invalid ProcessSelectionActionType' + selectedProcessOption.actionType);
    }
  }

  private buildAndApplySelectionModelToContext() {

    this.httpService.post<VisitorType[]>(environment.registrationVisitorFindVisitorRolesEndpoint, {}).subscribe(result => {
      if (result != null) {
        for (const entry of result) {
          const visitorType = new VisitorType(entry);

          const option = new ProcessSelectOption({
            key: visitorType.id,
            titleDictionaryEntry: visitorType.name,
            titleIconCss: visitorType.icon,
            descriptionDictionaryKey: '',
            processStepKey: this.getNextProcessStepByRoleMapping(entry.externalKey),
            actionType: ProcessSelectionActionType.PROCESS_STEP
          });
          this.selectOptions.push(option);

          if(visitorType.id === this.dashboardContext.getContextValue('visitorType')
          	&& this.wizardComponent.currentStep.dashboardConfiguration?.autoselect === true) {
            this.dashboardContext.setContextValue('selectedProcessOption', option);
            return;
          }
        }
      }
      this.dashboardContext.setContextValue('dashboardConfiguration',
        new ProcessSelectionConfiguration({ selectOptions: this.selectOptions }));
    }, error => {
      console.error('Failed to find visitor roles', error);
    });

  }

  private getNextProcessStepByRoleMapping(externalKey: string) {
    const mapping = this.wizardComponent.currentStep.dashboardConfiguration?.roleToProcessStepMapping;
    if (externalKey == null || externalKey.trim().length === 0 || mapping[externalKey] == null) {
      const defaultConfig = this.wizardComponent.currentStep.dashboardConfiguration?.roleDefaultProcessStep;
      const defaultProcessingStepKey = defaultConfig?.default;

      if (defaultProcessingStepKey == null) {
        console.error('roleDefaultProcessStep not found for VisitorRole external Key' + externalKey);
      }

      return defaultProcessingStepKey;
    }
    return mapping[externalKey];
  }

}
